import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=60d78c7f&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=60d78c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d78c7f",
  null
  
)

export default component.exports